import { render, staticRenderFns } from "./en-cultural.vue?vue&type=template&id=2eb911b6&scoped=true"
import script from "./en-cultural.vue?vue&type=script&lang=js"
export * from "./en-cultural.vue?vue&type=script&lang=js"
import style0 from "./en-cultural.vue?vue&type=style&index=0&id=2eb911b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb911b6",
  null
  
)

export default component.exports